import { FC } from 'react';

import { BreakdownsResult, EMetric, StatsResult } from 'api/useAnalytics';

import { Card, CardContent, CardHeader } from 'components/ui/card';

import { AnalyticsBoxHeader } from './AnalyticsBoxHeader/AnalyticsBoxHeader';

type AnalyticsBoxProps = {
  stat?: StatsResult;
  breakdown?: BreakdownsResult;
  shouldHideIndicator?: boolean;
  metricName: EMetric;
  children: React.ReactNode;
};

export const AnalyticsBox: FC<AnalyticsBoxProps> = ({
  stat,
  metricName,
  breakdown,
  children
}) => {
  return (
    <Card className="p-[24px] shadow-none min-h-[386px]">
      <CardHeader className="p-0">
        <AnalyticsBoxHeader
          stat={stat}
          breakdown={breakdown}
          metricName={metricName}
        />
      </CardHeader>
      <CardContent className="p-0">{children}</CardContent>
    </Card>
  );
};
